import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomSelect from "../components/CustomSelect";
import './ProductManagementBody.css';
import editIcon from '../assets/edit-icon.svg';
import versionIcon from '../assets/version-icon.svg';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { formatMoney } from '../utils/formatMoney';
import { productService } from './ProductService';
import { useAccess } from "../hooks/useAccess";
import noFilterIcon from '../assets/no-filter.svg';
import { getUser } from "../auth";
import { hasAccess } from "../utils/roleAccess";
// import { useLocation } from "react-router-dom";
import { useOverflowTooltip } from "../hooks/useOverflowTooltip";
import CustomTooltip from "../components/CustomTooltip";
import Breadcrumbs from '../components/Breadcrumbs';
import EntityMultiSelect from "../components/EntityMultiSelect";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ConfirmModal from "../components/ConfirmModal";
import ProductsIcon from '../assets/products_icon';
import axios, {API_BASE_URL as API_BASE} from "../axiosSetup";

const ProductAnalyticsCard = ({
  title,
  icon,
  total = 0,
  active = 0,
  onClick,
}) => {
  const safeActive = Math.max(0, Math.min(active, total));

  title = title === undefined || title === null
    ? "Total Unique Products"
    : title + " Products";

  const percentage =
    total > 0
      ? Math.round((safeActive / total) * 100)
      : 0;

  return (
    <div className="stats-card" onClick={onClick}>
      <div className="card-header">
        <div className="icon-box">
          {icon!==undefined && icon!==null ? icon : <ProductsIcon />}
        </div>
        <div><p>{title}</p></div>
      </div>

      <div className="card-content">
        <div className="card-content-left">
          <h2>{total}</h2>
          <div className="active-count">{safeActive} Active </div>
        </div>

        <div
          className="progress-circle"
          style={{
            "--percentage": percentage,
          }}
        >
          <div className="progress-inner">
            <span>{percentage}%</span>
            <small>Active</small>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProductManagementBody = () => {
  const navigate = useNavigate();
  const tableWrapperRef = useRef(null);
 
  const [products, setProducts] = useState([]);
  const [analytics, setAnalytics] = useState([]);
  const [productGroups, setProductGroups] = useState([]);
  const [productBrands, setProductBrands] = useState([]);
  const [entities, setEntities] = useState([]);
 const [showSearchValidation, setShowSearchValidation] = useState(false);

  const [searchText, setSearchText] = useState('');
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedEntity, setSelectedEntity] = useState([]);
  const [entityCombinationChecked, setEntityCombinationChecked] = useState(false);
  const [showEntityPanel, setShowEntityPanel] = useState(false);
const isResettingRef = useRef(false);
const isFirstLoad = useRef(true);

 
  const [obsoleteFilter, setObsoleteFilter] = useState('');
  const [sellableFilter, setSellableFilter] = useState('');
  const [purchasableFilter, setPurchasableFilter] = useState('');
  const [activeFilter, setActiveFilter] = useState("");
const chipContainerRef = useRef(null);

 
  const [pageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
const [sortField, setSortField] = useState("");
const [sortOrder, setSortOrder] = useState("asc");
const [pageCorrected, setPageCorrected] = useState(false);
const [searchResults, setSearchResults] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);
const [showSearchDropdown, setShowSearchDropdown] = useState(false);
const [allProductCodes, setAllProductCodes] = useState([]);
const [stateRestored, setStateRestored] = useState(false);
const [togglingIds, setTogglingIds] = useState(new Set());
const [isPageLoading, setIsPageLoading] = useState(true);
const isTableUpdating = isPageLoading && products.length > 0;
const searchRef = useRef(null);
const groupRef = useRef(null);
const [showGroupDropdown, setShowGroupDropdown] = useState(false);
const [groupSearchText, setGroupSearchText] = useState("");

const PM_STATE_KEY = "PRODUCT_MANAGEMENT_STATE";
const PM_ALLOW_RESTORE_KEY = "PM_ALLOW_RESTORE";
const PREVIEW_SIZE = 220;


const formatDate = (dateString, options = {}) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    ...options,
  });
};


const [confirmConfig, setConfirmConfig] = useState({
  open: false,
  title: "",
  message: "",
  confirmText: "",
  confirmType: "primary", // primary | danger
  onConfirm: () => {},
});

// 🔹 Open confirm modal
const openConfirm = (config) => {
  setConfirmConfig({
    open: true,
    title: config.title || "Confirm",
    message: config.message || "Are you sure?",
    confirmText: config.confirmText || "Confirm",
    confirmType: config.confirmType || "primary",
    onConfirm: config.onConfirm || (() => {}),
  });
};

// 🔹 Close confirm modal
const closeConfirm = () => {
  setConfirmConfig((prev) => ({
    ...prev,
    open: false,
  }));
};

// 🔹 Handle confirm click
const handleConfirmClick = async () => {
  await confirmConfig.onConfirm();
  closeConfirm();
};
 
  //  Restore saved filters, search, and pagination when returning back
 //  RESTORE PRODUCT MANAGEMENT STATE (Browser Back support)
useEffect(() => {
  const savedState = sessionStorage.getItem(PM_STATE_KEY);

  if (savedState) {
    const s = JSON.parse(savedState);

    setSearchText(s.searchText ?? "");
    setSelectedGroup(
      Array.isArray(s.selectedGroup)
        ? s.selectedGroup.slice(-5)
        : s.selectedGroup && s.selectedGroup !== "__placeholder__" && s.selectedGroup !== "All"
          ? [s.selectedGroup]
          : []
    );
    setSelectedBrand(
      s.selectedBrand === "__placeholder__" ? "" : s.selectedBrand ?? ""
    );
    setSelectedEntity(s.selectedEntity ?? []);
    setEntityCombinationChecked(Boolean(s.entityCombinationChecked));
    setSelectedProducts(s.selectedProducts ?? []);
    setObsoleteFilter(
      s.obsoleteFilter === "__placeholder__" ? "" : s.obsoleteFilter ?? ""
    );
    setSellableFilter(
      s.sellableFilter === "__placeholder__" ? "" : s.sellableFilter ?? ""
    );
    setPurchasableFilter(
      s.purchasableFilter === "__placeholder__" ? "" : s.purchasableFilter ?? ""
    );
    setActiveFilter(
      s.activeFilter === "__placeholder__" ? "" : s.activeFilter ?? ""
    );
    setCurrentPage(s.currentPage ?? 1);
    setSortField(s.sortField ?? "");
    setSortOrder(s.sortOrder ?? "asc");
  }

  setStateRestored(true);
}, []);

useEffect(() => {
  return () => {
    const allowRestore = sessionStorage.getItem(PM_ALLOW_RESTORE_KEY);

    // ❌ Navigating away WITHOUT permission → clear
    if (!allowRestore) {
      sessionStorage.removeItem(PM_STATE_KEY);
    }

    // always consume the flag
    sessionStorage.removeItem(PM_ALLOW_RESTORE_KEY);
  };
}, []);

 //  User Role Access (Corrected)
const getProductPermissions = () => {
  try {
    const stored = sessionStorage.getItem("APP_USER_INFO");
    if (!stored) return {};

    const user = JSON.parse(stored);

    const productService = user.services?.find(
      (s) => s.service === "Product Management"
    );

    const ops = productService?.operations || [];

    return {
      canCreate: ops.includes("CREATE"),
      canUpdate: ops.includes("UPDATE"),
      canRead: ops.includes("READ"),
    };
  } catch {
    return {};
  }
};

const {
  canCreate,
  canUpdate,
  canRead,
} = getProductPermissions();

const canAdd = canCreate;
const canEdit = canUpdate;
const canToggle = canUpdate;
const canView = canRead;
const canViewHistory = canRead;
const isViewOnly = canRead;


useEffect(() => {
  if (!stateRestored) return;
  if (isResettingRef.current) return;

  const stateToSave = {
    searchText,
    selectedGroup,
    selectedBrand,
    selectedEntity,
    entityCombinationChecked,
    selectedProducts,
    obsoleteFilter,
    sellableFilter,
    purchasableFilter,
    currentPage,
    sortField,
    sortOrder,
    activeFilter
  };

  sessionStorage.setItem(
    "PRODUCT_MANAGEMENT_STATE",
    JSON.stringify(stateToSave)
  );
}, [
  stateRestored,
  searchText,
  selectedGroup,
  selectedBrand,
  selectedEntity,
  entityCombinationChecked,
  selectedProducts,
  obsoleteFilter,
  sellableFilter,
  purchasableFilter,
  activeFilter,
  currentPage,
  sortField,
  sortOrder,
]);

  // Sticky column shadow behaviour
  useEffect(() => {
    const el = tableWrapperRef.current;
    if (!el) return;
 
    const handleScroll = () => {
      el.classList.toggle("scrolled-left", el.scrollLeft > 5);
      el.classList.toggle(
        "scrolled-right",
        el.scrollWidth - el.clientWidth - el.scrollLeft > 5
      );
    };
 
    el.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);
 
// useEffect(() => {
//   setPageCorrected(false);
//   loadProducts();
// }, [ ... ]);


 
useEffect(() => {
  if (!stateRestored) return;
  if (isFirstLoad.current) {  
    loadProducts().then(() => {
      isFirstLoad.current = false;
    });           
    return;                            
  }

  setPageCorrected(false);
  loadProducts();
}, [
  stateRestored,
  currentPage,
  selectedGroup,
  selectedBrand,
  selectedEntity,
  entityCombinationChecked,
  obsoleteFilter,
  sellableFilter,
  purchasableFilter,
  selectedProducts,
  activeFilter,
  sortField,
  sortOrder
]);

const fetchProductCodes = async () => {
  try {
    const params = new URLSearchParams();

    if (selectedEntity.length > 0) {
      selectedEntity.forEach((e) => {
        params.append("entity", e);
      });
      params.append("exactMatch", String(Boolean(entityCombinationChecked)));
    }
    selectedGroup.forEach((group) => params.append("productGroup", group));

    if (obsoleteFilter && obsoleteFilter !== "All") {
      params.append("obsolete",obsoleteFilter === "Include Archived");
    }
    if (sellableFilter && sellableFilter !== "All") {
      params.append("sellable",sellableFilter === "Sellable");
    }
    if (purchasableFilter && purchasableFilter !== "All") {
      params.append("purchasable",purchasableFilter === "Purchasable");
    }
    if (activeFilter && activeFilter !== "All") {
      params.append("active",activeFilter === "Active");
    }
    const res = await axios.get(
      `/product/dropdown/product-codes?${params.toString()}`
    );

    const products = res.data;
    setAllProductCodes(products?.map(p => ({
      productCode:p?.productCode,
      productDescription:p?.productDescription,
    })));
    console.log(allProductCodes);
  } catch (err) {
    console.error("Error fetching product codes:", err);
  }
};



useEffect(() => {
  fetchProductCodes();
}, [
  selectedEntity,
  entityCombinationChecked,
  selectedGroup,
  obsoleteFilter,
  sellableFilter,
  purchasableFilter,
  activeFilter,
]);

const handleReset = () => {
  isResettingRef.current = true;
  sessionStorage.removeItem("PRODUCT_MANAGEMENT_STATE");

  setSearchText("");
  setSelectedGroup([]);
  setSelectedBrand("");
  if (selectedEntity != undefined && selectedEntity.length > 0) {
    setSelectedEntity([]);
  }
  setEntityCombinationChecked(false);
  if (selectedProducts != undefined && selectedProducts.length > 0) {
    setSelectedProducts([]);
  }
  setObsoleteFilter("");
  setSellableFilter("");
  setPurchasableFilter("");
  setActiveFilter("");

  setCurrentPage(1);
  setSortField("");
  setSortOrder("asc");

  setTimeout(() => {
    isResettingRef.current = false;
  }, 0);
};


const loadProducts = async () => {
  setIsPageLoading(true);
  try {
    const params = { 
      page: currentPage,
      requiredAnalytics:isFirstLoad.current,
    };

    if (selectedProducts.length > 0) {
      params.productCode = selectedProducts;
    }

    if (selectedEntity.length > 0) {
      params.entity = selectedEntity;
      params.exactMatch = String(Boolean(entityCombinationChecked));
    }

    if (selectedGroup.length > 0) params.productGroup = selectedGroup;
    if (selectedBrand && selectedBrand !== "All") params.productBrand = selectedBrand;

    if (obsoleteFilter && obsoleteFilter !== "All") {
      params.obsolete = obsoleteFilter === "Include Archived";
    }
    if (sellableFilter && sellableFilter !== "All") {
      params.sellable = sellableFilter === "Sellable";
    }
    if (purchasableFilter && purchasableFilter !== "All") {
      params.purchasable = purchasableFilter === "Purchasable";
    }
    if (activeFilter && activeFilter !== "All") {
      params.active = activeFilter === "Active";
    }

    // 🔽 Backend sorting (ONLY one at a time)
if (sortField && sortOrder) {
  const order = sortOrder.toUpperCase(); // ASC | DESC

  switch (sortField) {
    case "buyPrice":
      params.orderByBuyPrice = order;
      break;

    case "productPrice":
      params.orderByProductPrice = order;
      break;

    case "productMargin":
      params.orderByProductMargin = order;
      break;

    default:
      break;
  }
}


    const data = await productService.getAll(params);

    const nextTotalPages = data.totalPages || 1;
    const nextTotalProducts =
      data.totalRecords ??
      data.totalElements ??
      data.totalItems ??
      data.totalProducts ??
      data.totalCount ??
      data.total ??
      ((nextTotalPages - 1) * pageSize + (data.products || []).length);

    setTotalPages(nextTotalPages);
    setTotalProducts(nextTotalProducts);

    if (currentPage > nextTotalPages && nextTotalPages > 0) {
      setCurrentPage(nextTotalPages);
      return;
    }

    const updated = (data.products || []).map((p) => ({
      ...p,
      finalImageUrl: p.imageUrl
  ? (p.imageUrl.startsWith("http")
      ? p.imageUrl
      : `${API_BASE}/product/${p.id}/image`)
  : "",
    }));

    setProducts(updated);
    if(isFirstLoad.current) setAnalytics(data.analytics || [] )
    setTotalPages(nextTotalPages);
    setTotalProducts(nextTotalProducts);
  } catch (error) {
    console.error("Error fetching products:", error);
  } finally {
    setIsPageLoading(false);
  }
};

const fetchSearchSuggestions = (value = "") => {
  const query = value.trim().toLowerCase();

  const filtered = allProductCodes
    .filter(p => {
      if (!query) return true;

      return (
        (p?.productCode ?? "").toLowerCase().includes(query) ||
        (p?.productDescription ?? "").toLowerCase().includes(query)
      );
    });

  setSearchResults(filtered);
  setShowSearchDropdown(true);
};

const toggleProductFilter = (productCode) => {
  setSelectedProducts(prev =>
    prev.includes(productCode)
      ? prev.filter(code => code !== productCode)
      : [...prev, productCode]
  );

  setSearchText("");
  setShowSearchDropdown(true);
  setShowSearchValidation(false);
};

const toggleProductGroupFilter = (group) => {
  setSelectedGroup((prev) => {
    if (group === "All") return [];
    if (prev.includes(group)) return prev.filter((selected) => selected !== group);

    return [...prev, group].slice(-5);
  });
  setCurrentPage(1);
};

const filteredProductGroups = [{
  productGroup:"All"
  },
  ...productGroups
].filter((group) =>
  group.productGroup?.toLowerCase().includes(groupSearchText.trim().toLowerCase())
);

const toggleProductSearchDropdown = () => {
  if (showSearchDropdown) {
    setShowSearchDropdown(false);
    return;
  }

  fetchSearchSuggestions(searchText);
};


 
// Helper component for overflow tooltip
const OverflowCell = ({ text }) => {
  const { ref, showTooltip } = useOverflowTooltip(text);
 
  return (
    <CustomTooltip
      message={text}
      placement="top"
      color="#4A1476"
      show={showTooltip}
    >
      <span ref={ref} className="pm-truncate">
        {text}
      </span>
    </CustomTooltip>
  );
};
 const MAX_VISIBLE_CHIPS = 50;

const visibleChips = selectedProducts.slice(0, MAX_VISIBLE_CHIPS);
const hiddenCount = selectedProducts.length - MAX_VISIBLE_CHIPS;
const paginationStart = totalProducts === 0 ? 0 : (currentPage - 1) * pageSize + 1;
const paginationEnd = Math.min(currentPage * pageSize, totalProducts);

const positionImagePreview = (event, productId) => {
  const preview = document.getElementById(`pm-preview-${productId}`);
  if (!preview) return;

  const offset = 18;
  const viewportPadding = 12;
  let left = event.clientX + offset;
  let top = event.clientY + offset;

  if (left + PREVIEW_SIZE > window.innerWidth - viewportPadding) {
    left = event.clientX - PREVIEW_SIZE - offset;
  }

  if (top + PREVIEW_SIZE > window.innerHeight - viewportPadding) {
    top = event.clientY - PREVIEW_SIZE - offset;
  }

  left = Math.max(viewportPadding, left);
  top = Math.max(viewportPadding, top);

  preview.style.left = `${left}px`;
  preview.style.top = `${top}px`;
};

const counts = useMemo(
  () =>
    Object.fromEntries(
      productGroups.map(g => [
        g.productGroup,
        Number(g.productCount),
      ])
    ),
  [productGroups]
);

  const loadDropdowns = async () => {
    try {
      const [ brandsRes, entityRes] = await Promise.all([
        axios.get("/dropdown/product-brands"),
        axios.get("/dropdown/entity"),
      ]);
  
      if (brandsRes.data) setProductBrands(brandsRes.data);
      if (entityRes.data) {
        setEntities(entityRes.data.map(e => e.entity));
        }
    } catch (err) {
      console.error('Error loading dropdowns:', err);
    }
  };
const fetchProductGroups = async () => {
  const params = new URLSearchParams();
 
  if (selectedEntity.length > 0) {
    selectedEntity.forEach((e) => params.append("entity", e));
    params.append(
      "exactMatch",
      String(Boolean(entityCombinationChecked))
    );
  }
 
  if (obsoleteFilter && obsoleteFilter !== "All") {
    params.append(
      "obsolete",
      obsoleteFilter === "Include Archived"
    );
  }
 
  if (sellableFilter && sellableFilter !== "All") {
    params.append(
      "sellable",
      sellableFilter === "Sellable"
    );
  }
 
  if (purchasableFilter && purchasableFilter !== "All") {
    params.append(
      "purchasable",
      purchasableFilter === "Purchasable"
    );
  }
 
  if (activeFilter && activeFilter !== "All") {
    params.append(
      "active",
      activeFilter === "Active"
    );
  }
 
   const res = await axios.get(
    `/product/dropdown/product-groups?${params.toString()}`
  );
  
  setProductGroups(res.data);
};
 
useEffect(() => {
  fetchProductGroups();
}, [
  selectedEntity,
  entityCombinationChecked,
  obsoleteFilter,
  sellableFilter,
  purchasableFilter,
  activeFilter,
]);
 
 const handleAddProductClick = () => {
   sessionStorage.setItem(PM_ALLOW_RESTORE_KEY, "true");
  navigate("/products/add-product", {
    state: {
      searchText,
      selectedGroup,
      selectedBrand,
      selectedEntity,
      obsoleteFilter,
      sellableFilter,
      purchasableFilter,
      currentPage
    }
  });
};
 
const handleSort = (field) => {
  if (sortField === field) {
    // toggle
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  } else {
    setSortField(field);
    setSortOrder("asc");
  }
};

const handleEntityFilterModeChange = (checked) => {
  if (selectedEntity.length === 0) return;

  setEntityCombinationChecked(checked);
  setCurrentPage(1);
};

 useEffect(() => {
  const handleClickOutside = (e) => {
    if (searchRef.current && !searchRef.current.contains(e.target)) {
      setShowSearchDropdown(false);
    }
    if (groupRef.current && !groupRef.current.contains(e.target)) {
      setShowGroupDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);
useEffect(() => {
  if (!chipContainerRef.current) return;

  chipContainerRef.current.scrollTo({
    left: chipContainerRef.current.scrollWidth,
    behavior: "smooth"
  });
}, [selectedProducts]);

  const handleToggle = async (product) => {
  // 🚫 BLOCK duplicate calls
  if (togglingIds.has(product.id)) return;

  setTogglingIds(prev => {
    const next = new Set(prev);
    next.add(product.id);
    return next;
  });

  try {
    const increment=!product.active;
    await productService.toggleActive(product.id, !product.active);

    // Optimistic UI update
    setProducts(prev =>
      prev.map(p =>
        p.id === product.id
          ? { ...p, active: !p.active }
          : p
      )
    );
    console.log(product);
    setAnalytics(prev =>
      prev.map(a =>
        a.entity === undefined || a.entity===null || (product.entity??[]).includes(a.entity)
          ? { 
            ...a, 
            active: increment
             ? a.active+1
             : Math.max(0, a.active - 1),
          }
          : a
      )
    );
  } catch (error) {
    console.error("Error updating status:", error);
  } finally {
    setTogglingIds(prev => {
      const next = new Set(prev);
      next.delete(product.id);
      return next;
    });
  }
};

 const dropdownLoadedRef = useRef(false);

useEffect(() => {
  if (dropdownLoadedRef.current) return;
  dropdownLoadedRef.current = true;

  loadDropdowns();
}, []);

  const handlePageChange = (page) => setCurrentPage(page);
 
  const renderPageNumbers = () => {
  const pages = [];
 
  // Always show page 1
  pages.push(
    <button
      key={1}
      className={`pm-page-number ${currentPage === 1 ? "active" : ""}`}
      onClick={() => handlePageChange(1)}
    >
      1
    </button>
  );
 
  // Left ellipsis
  if (currentPage > 3) {
    pages.push(<span key="ellipsis1" className="pm-page-ellipsis">...</span>);
  }
 
  // Middle numbers
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(currentPage + 1, totalPages - 1);
    i++
  ) {
    pages.push(
      <button
        key={i}
        className={`pm-page-number ${currentPage === i ? "active" : ""}`}
        onClick={() => handlePageChange(i)}
      >
        {i}
      </button>
    );
  }
 
  // Right ellipsis
  if (currentPage < totalPages - 2) {
    pages.push(<span key="ellipsis2" className="pm-page-ellipsis">...</span>);
  }
 
  // Last page
  if (totalPages > 1) {
    pages.push(
      <button
        key={totalPages}
        className={`pm-page-number ${currentPage === totalPages ? "active" : ""}`}
        onClick={() => handlePageChange(totalPages)}
      >
        {totalPages}
      </button>
    );
  }
 
  return pages;
};
 
 
  return (
    isPageLoading && products.length === 0 ? (
      <div style={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 34, color: "#f50087" }} spin />} />
          <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>
        </div>
      </div>
    ) : (
    <div className="pm-body-container">
 
      {/* Header */}
      <div className="pm-header-wrap">
          {/* LEFT */}
          <div className="pm-header-left">
           <Breadcrumbs
                      stateKey="PRODUCT_MANAGEMENT_STATE"
                    />

          </div>

          {/* RIGHT */}
          
        </div>

 
      <div className="pm-main-frame">
        <div className="pm-analytics">
          {
            analytics.map(a=><ProductAnalyticsCard
              title={a.entity}
              total={a.total}
              active={a.active}
              icon={a.currency}
              onClick={(e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (a.entity) {
                  const entityChanged =
                    selectedEntity.length !== 1 ||
                    selectedEntity[0] !== a.entity;

                  const combinationChanged = entityCombinationChecked !== false;

                  if (entityChanged || combinationChanged) {
                    if (entityChanged) {
                      setSelectedEntity([a.entity]);
                    }

                    if (combinationChanged) {
                      setEntityCombinationChecked(false);
                    }
                  }
                }else{
                  setActiveFilter("Active")
                }
              }}
            />)
          }
        </div>
 
        {/* Card header */}
       
  {/* LEFT SIDE */}
  {/* <div className="pm-card-header-left">
    <h2 className="pm-product-title">Products</h2>
    <p className="pm-product-subtitle">Browse and manage your product catalog</p>
  </div> */}


 
 
        {/* Filters */}
        <div className="pm-search-filter-frame">
 
          {/* Row 1 */}
          <div className="pm-filter-row pm-filter-row-1">
 
                <div className="pm-filter-item">
                  <div className="pm-entity-select">
                    <EntityMultiSelect
                      options={entities}
                      selected={selectedEntity}
                      showCombinationOption
                      combinationChecked={entityCombinationChecked}
                      onCombinationChange={handleEntityFilterModeChange}
                      onChange={(updatedSelected) => {
                        setSelectedEntity(updatedSelected);
                        if (updatedSelected.length === 0) {
                          setEntityCombinationChecked(false);
                        }
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <div className="pm-filter-item">
                  <div className="custom-select-container" ref={groupRef}>
                    <div
                      className="custom-select-header"
                      onClick={() => setShowGroupDropdown((prev) => !prev)}
                    >
                      <span className={selectedGroup.length ? "custom-select-value" : "custom-select-placeholder"}>
                        {selectedGroup.length ? selectedGroup.join(", ") : "Select Product Group"}
                      </span>
                      <span className="arrow">
                        {showGroupDropdown ? <FiChevronUp /> : <FiChevronDown />}
                      </span>
                    </div>

                    {showGroupDropdown && (
                      <div className="pm-search-dropdown pm-group-dropdown">
                        <div style={{ color: "#7509B8", fontSize: "12px", padding: "6px 6px 0px 6px" }}>
                          Total Product Groups: {productGroups.length} {productGroups.length > 0 ? "" : "(No groups available)"}  
                        </div>
                        <input
                          className="pm-search-dropdown-input"
                          type="text"
                          placeholder="Search..."
                          value={groupSearchText}
                          onChange={(e) => setGroupSearchText(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <div className="pm-search-dropdown-list pm-group-dropdown-list">
                          {filteredProductGroups.length > 0 ? (
                            filteredProductGroups.map((group) => (
                              <div
                                key={group.productGroup}
                                className="pm-search-option"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleProductGroupFilter(group.productGroup);
                                }}
                              >
                                <input
                                  className="pm-search-option-checkbox"
                                  type="checkbox"
                                  checked={
                                    group === "All"
                                      ? selectedGroup.length === 0
                                      : selectedGroup.includes(group.productGroup)
                                  }
                                  readOnly
                                />
                                <div className="pm-code-filter">
                                  <div className="pm-group-name">{group.productGroup}{group.productCount?` (${group.productCount})`:""}</div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="pm-search-no-data">No results found</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="pm-filter-item search">
                  <div className="filter-search" ref={searchRef}>
                    <div
                      className="pm-multiselect-input"
                      ref={chipContainerRef}
                      onClick={toggleProductSearchDropdown}
                    >

                      {visibleChips.map(code => (
                        <span key={code} className="pm-chip">
                          {code}
                          <span
                            className="pm-chip-close"
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedProducts(prev => prev.filter(p => p !== code));
                            }}
                          >
                            ×
                          </span>
                        </span>
                      ))}

                      {hiddenCount > 0 && (
                        <span className="pm-chip pm-chip-more">
                          +{hiddenCount}
                        </span>
                      )}
                      <input
                        type="text"
                        className="product-search-input"
                        placeholder="Select Product Code/Description"
                        value=""
                        readOnly
                      />
                      <span
                        className="pm-search-select-arrow"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleProductSearchDropdown();
                        }}
                      >
                        {showSearchDropdown ? <FiChevronUp /> : <FiChevronDown />}
                      </span>
                    </div>


                    {showSearchDropdown && (
                      <div className="pm-search-dropdown">

                        <div style={{ color: "#7509B8", fontSize: "12px", padding: "6px 6px 0px 6px" }}>
                          Please select a product from the list to apply filter
                        </div>

                        {/*  SEARCH INSIDE DROPDOWN */}
                        <input
                          className="pm-search-dropdown-input"
                          type="text"
                          placeholder={selectedProducts.length === 0 ? "Search..." : ""}
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                            fetchSearchSuggestions(e.target.value);
                          }}
                          onFocus={() => fetchSearchSuggestions(searchText)}
                          onClick={(e) => e.stopPropagation()}
                        />

                        <div className="pm-search-dropdown-list">
                          {searchResults.length > 0 ? (
                            searchResults.map(p => (
                              <div
                                key={p.productCode}
                                className="pm-search-option"
                                onClick={(e) => {
                                  e.stopPropagation(); //  prevent outside click close
                                  toggleProductFilter(p.productCode);
                                }}
                              >
                                <input
                                  className="pm-search-option-checkbox"
                                  type="checkbox"
                                  checked={selectedProducts.includes(p.productCode)}
                                  readOnly
                                />
                                <div className="pm-code-filter">
                                  <div className="pm-code">{p.productCode}</div>
                                  <div className="pm-description">{p.productDescription}</div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="pm-search-no-data">No results found</div>
                          )}
                        </div>

                      </div>
                    )}



                  </div>
                </div>
            <div className="pm-filter-item">
              <CustomSelect
                className="filter-obsolete"
                value={obsoleteFilter}
                onChange={(v) => setObsoleteFilter(v)}
                options={["All", "Include Archived", "Exclude Archived"]}
                placeholder="Select Archive Status"
              />
            </div>
 
            {/* <div className="pm-filter-item">
              {/* <CustomSelect
                className="filter-brand"
                value={selectedBrand === "__placeholder__" ? "" : selectedBrand}
                onChange={(v) => {
    setSelectedBrand(v === "All" ? "__placeholder__" : v);
  }}
   options={["All", ...productBrands]}
                placeholder="Product Brand"
              /> *//*}
            </div> */}
 
          </div>
 
          {/* Row 2 */}
          <div className="pm-filter-row pm-filter-row-2">
 
            
 
            <div className="pm-filter-item">
              <CustomSelect
                className="filter-sellable"
                value={sellableFilter}
                onChange={(v) => setSellableFilter(v)}
                options={["All", "Sellable", "Not Sellable"]}
                placeholder="Available for Sale"
              />
            </div>
 
            <div className="pm-filter-item">
              <CustomSelect
                className="filter-purchasable"
                value={purchasableFilter}
                onChange={(v) => setPurchasableFilter(v)}
                options={["All", "Purchasable", "Not Purchasable"]}
                placeholder="Available for Purchase"
              />
            </div>
            {/* filter for active and inactive  */}
            <div className="pm-filter-item">
            <CustomSelect
              value={activeFilter}
              onChange={(v) => {
                setActiveFilter(v);
                setCurrentPage(1);
              }}
              options={["All", "Active", "Inactive"]}
              placeholder="Select Product Status"
            />
          </div>
          {/* RIGHT SIDE */}
  <div className="pm-card-header-right">
   <div className="pm-header-right">
            {/* <span className="anp-reset-text" onClick={handleReset}>
              Reset
            </span> */}
            <CustomTooltip message="Clear filters" placement="top" color="#4A1476">
              <button
                type="button"
                className="no-filter-reset"
                onClick={handleReset}
                aria-label="Clear filters"
              >
                <span
                  className="no-filter-reset-icon"
                  style={{ WebkitMaskImage: `url(${noFilterIcon})`, maskImage: `url(${noFilterIcon})` }}
                />
              </button>
            </CustomTooltip>
          </div>

    {canAdd && (
      <button
        className="pm-button pm-button-primary"
        onClick={handleAddProductClick}
      >
        + Add Product
      </button>
    )}
  </div>

 
          </div>
 
        </div>
 
        {/* Table */}
        <div className="pm-table-frame">
          {isTableUpdating && (
            <div className="pm-table-loading-overlay">
              <Spin indicator={<LoadingOutlined style={{ fontSize: 28, color: "#f50087" }} spin />} />
            </div>
          )}
          <div 
            id="pm-table-wrapper" 
            className="pm-table-wrapper" 
            ref={tableWrapperRef}
            onScroll={(e) => {
              document
                .querySelectorAll(".pm-group-section-title")
                .forEach((el) => {
                  el.style.transform = `translateX(${e.currentTarget.scrollLeft}px)`;
                });
            }}
          >
            <table className="pm-table">
              <thead className="pm-table-header">
                <tr>
                  <th className="sticky-col-left-1">Image</th>
                  <th className="sticky-col-left-2">Entity</th>
 
                  <th className="pm-table-pd">Product Code</th>
                  <th className="pm-col-description">Product Description</th>
                  <th className="pm-col-group">Product Group</th>
                 <th className="pm-col-buy-price" onClick={() => handleSort("buyPrice")}>
                <div className="pm-sortable">
                    Buy Price
                    <span className="pm-sort-icons">
                      <span className={`pm-sort-icon ${sortField === "buyPrice" && sortOrder === "asc" ? "active" : ""}`}>▲</span>
                      <span className={`pm-sort-icon ${sortField === "buyPrice" && sortOrder === "desc" ? "active" : ""}`}>▼</span>
                    </span>
                    </div>
                  </th>
 
                  <th className="pm-col-product-price" onClick={() => handleSort("productPrice")} >
                    <div className="pm-sortable">
                    Product Price
                    <span className="pm-sort-icons">
                      <span className={`pm-sort-icon ${sortField === "productPrice" && sortOrder === "asc" ? "active" : ""}`}>▲</span>
                      <span className={`pm-sort-icon ${sortField === "productPrice" && sortOrder === "desc" ? "active" : ""}`}>▼</span>
                    </span>
                    </div>
                  </th>
 
                  <th className="pm-col-margin" onClick={() => handleSort("productMargin")}>
                    <div className="pm-sortable">
                    Margin (%)
                    <span className="pm-sort-icons">
                      <span className={`pm-sort-icon ${sortField === "productMargin" && sortOrder === "asc" ? "active" : ""}`}>▲</span>
                      <span className={`pm-sort-icon ${sortField === "productMargin" && sortOrder === "desc" ? "active" : ""}`}>▼</span>
                    </span>
                    </div>
                  </th>

                      <th className="pm-col-created-date">
                        Created Date
                      </th>

                      <th className={isViewOnly ? "sticky-col-right-1" : "sticky-col-right-2"}>
                        Active
                      </th>

{(canEdit || canViewHistory) && (
  <th className="sticky-col-right-1">
    Actions
  </th>
)}
 
                </tr>
              </thead>
 
              <tbody className="pm-table-body">
                {products.length > 0 ? (
                  products.map((product, index) => {
                    const productGroup = String(product.productGroup ?? "").trim() || "Other";
                    const previousProductGroup =
                      String(products[index - 1]?.productGroup ?? "").trim() || "Other";
                    const showProductGroupHeading =
                      index === 0 || productGroup !== previousProductGroup;

                    return (
                    <React.Fragment key={product.id}>
                      {showProductGroupHeading && (
                        <tr className="pm-group-section-row">
                          <td className="pm-group-section-cell" colSpan="11">
                            <div className="pm-group-section-title">{`${productGroup} (${counts[productGroup] ?? 0})`}</div>
                          </td>
                        </tr>
                      )}
                      <tr>
                      <td className="sticky-col-left-1">
  <div
    className="pm-image-hover-wrapper"
    onMouseEnter={(e) => positionImagePreview(e, product.id)}
    onMouseMove={(e) => positionImagePreview(e, product.id)}
  >
    {product.finalImageUrl ? (
      <img
        src={product.finalImageUrl}
        width={40}
        height={40}
        alt="Product"
        className="pm-product-image"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.style.display = "none";
        }}
      />
    ) : (
      <div style={{ width: 40, height: 40 }} />
    )}

    {/* 🔥 HOVER PREVIEW */}
    {product.finalImageUrl && (
      <div id={`pm-preview-${product.id}`} className="pm-hover-preview">
        <img
          src={product.finalImageUrl}
          alt="Preview"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
    )}
  </div>
</td>
                      {/* ENTITY */}
                      <td className="sticky-col-left-2">{product.entity?.join(', ') || '-'}</td>
 
                      {/* PRODUCT CODE */}
                      <td className={isViewOnly ? "" : "pm-link-cell"}
                        onClick={() => {
                        if (canEdit) {
                          sessionStorage.setItem(PM_ALLOW_RESTORE_KEY, "true");
                          navigate(`/products/edit/${product.id}`, { state: { product } });
                        }
                      }}
                      >
                         <OverflowCell text={product.productCode} />
                      </td>
                      <td
                        className={`pm-col-description ${isViewOnly ? "" : "pm-link-cell"}`.trim()}
                        onClick={() => {
  if (!isViewOnly) {
    sessionStorage.setItem(PM_ALLOW_RESTORE_KEY, "true");
    navigate(`/products/edit/${product.id}`, { state: { product } });
  }
}}
                      >
                        <OverflowCell text={product.productDescription?.trim() ? product.productDescription : "-"} />
                      </td>
 
                      <td className="pm-col-group"><OverflowCell text={product.productGroup} /></td>
 
                      <td className="number-col pm-col-buy-price">
                        {typeof product.buyPrice === "string" && product.buyPrice.trim()
                          ? product.buyPrice
                          : formatMoney(product.buyPrice, product.currency)}
                      </td>
                      <td className="number-col pm-col-product-price">
                        {typeof product.productPrice === "string" && product.productPrice.trim()
                          ? product.productPrice
                          : formatMoney(product.productPrice, product.currency)}
                      </td>

                        <td className="number-col pm-col-margin">
                        {product.productMargin !== null && product.productMargin !== undefined
                          ? <div style={{
                            color: Number(product.productMargin) < 0 ? "red" : "inherit",
                          }}>
                            {Number(product.productMargin).toFixed(2)}%
                          </div>
                          : '-'}
                      </td>
                          <td className="pm-col-created-date">
                            {formatDate(product.createdAt)}
                          </td>
                      {/* ACTIVE */}
<td className={!isViewOnly ? "sticky-col-right-2" : "sticky-col-right-1"}>
                        <label className="pm-toggle">
                          <input
                            type="checkbox"
                            checked={!!product.active}
                            disabled={!canUpdate || togglingIds.has(product.id)}
                            onChange={(e) =>{
                              e.stopPropagation();
                              e.preventDefault();
                                if(!canToggle){
                                  return;
                                }

                                const action = product.active ? "Deactivate" : "Activate";
                                openConfirm({
                                  title: `${action} Product`,
                                  message: `Are you sure you want to ${action.toLowerCase()} this product?`,
                                  confirmText: action,
                                  confirmType: product.active ? "danger" : "primary",
                                  onConfirm: async () => handleToggle(product),
                                });
                            }}
                          /> 
                          <span className="pm-toggle-slider"></span>
                        </label>
                      </td>
 
                      {/* ACTIONS */}
                      
                      <td className="pm-table-actions sticky-col-right-1">
                        {canEdit && (
                              <CustomTooltip message="Edit Product" placement="top" color="#4A1476">
                        <button
                          className="pm-edit-btn"
                          onClick={() => {
    sessionStorage.setItem(PM_ALLOW_RESTORE_KEY, "true");
    navigate(`/products/edit/${product.id}`, { state: { product } });
  }}
                        >
                          <img src={editIcon} alt="edit" width={16} />
                        </button> </CustomTooltip>)}

                        {canViewHistory && (
                         <CustomTooltip message="View Product History" placement="top" color="#4A1476">
                          <button
                          className="pm-history-btn"
                           onClick={() => {
    sessionStorage.setItem(PM_ALLOW_RESTORE_KEY, "true");
    navigate(`/products/${product.id}/history`, {
      state: { product }
    });
  }}
                        >
                          <img src={versionIcon} alt="history" width={16} />
                        </button></CustomTooltip>)}
                      </td>
 
                      </tr>
                    </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="11" style={{ textAlign: "center", padding: 20 }}>
                      No products found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
 
        {/* Pagination */}
        <div className="pm-pagination-frame">
  <div className="pm-pagination-info">
    {paginationStart} - {paginationEnd} of {totalProducts}
  </div>
 
  <div className="pm-pagination-controls">
    <button
      className="pm-pagination-arrow"
      disabled={currentPage === 1}
      onClick={() => handlePageChange(currentPage - 1)}
    >
      ‹
    </button>
 
    <div className="pm-pagination-numbers">{renderPageNumbers()}</div>
 
    <button
      className="pm-pagination-arrow"
      disabled={currentPage === totalPages}
      onClick={() => handlePageChange(currentPage + 1)}
    >
      ›
    </button>
  </div>
</div>
       </div>

       <ConfirmModal
        open={confirmConfig.open}
        title={confirmConfig.title}
        message={confirmConfig.message}
        confirmText={confirmConfig.confirmText}
        cancelText="Cancel"
        confirmType={confirmConfig.confirmType}
        onCancel={closeConfirm}
        onConfirm={handleConfirmClick}
      />
    </div>
    )
  );
};
 
export default ProductManagementBody;
 
